(function () {
  var STORAGE_KEY = 'gz-wishlist';
  var EVENT = 'gz:wishlist-change';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { items: list } }));
  }

  function has(id) {
    return read().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function add(item) {
    if (!item || !item.id) return read();
    var list = read().filter(function (entry) {
      return String(entry.id) !== String(item.id);
    });
    list.unshift({
      id: String(item.id),
      handle: item.handle || '',
      title: item.title || '',
      url: item.url || '',
      image: item.image || '',
      price: item.price || '',
      compare: item.compare || ''
    });
    write(list);
    return list;
  }

  function remove(id) {
    var list = read().filter(function (item) {
      return String(item.id) !== String(id);
    });
    write(list);
    return list;
  }

  function toggle(item) {
    if (!item || !item.id) return { active: false, items: read() };
    if (has(item.id)) {
      return { active: false, items: remove(item.id) };
    }
    return { active: true, items: add(item) };
  }

  function itemFromButton(btn) {
    if (!btn) return null;
    var id = btn.getAttribute('data-product-id');
    if (!id) return null;
    return {
      id: id,
      handle: btn.getAttribute('data-product-handle') || '',
      title: btn.getAttribute('data-product-title') || '',
      url: btn.getAttribute('data-product-url') || '',
      image: btn.getAttribute('data-product-image') || '',
      price: btn.getAttribute('data-product-price') || '',
      compare: btn.getAttribute('data-product-compare') || ''
    };
  }

  function syncButtons(list) {
    var ids = {};
    (list || read()).forEach(function (item) {
      ids[String(item.id)] = true;
    });
    qsa('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (!id) return;
      var on = !!ids[String(id)];
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function updateCount(list) {
    var count = (list || read()).length;
    qsa('[data-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
  }

  function moneyFallback(text) {
    return text || '';
  }

  function renderDrawer(list) {
    var body = qs('[data-wishlist-drawer-body]');
    if (!body) return;
    var items = list || read();
    var emptyText = body.getAttribute('data-empty') || 'Favori listeniz boş';
    var removeText = body.getAttribute('data-remove') || 'Kaldır';
    var continueText = body.getAttribute('data-continue') || 'Alışverişe devam et';

    if (!items.length) {
      body.innerHTML =
        '<div class="wishlist-drawer__empty">' +
        '<p>' +
        emptyText +
        '</p>' +
        '<button type="button" class="btn btn--brand" data-wishlist-close>' +
        continueText +
        '</button></div>';
      return;
    }

    body.innerHTML =
      '<ul class="wishlist-drawer__items">' +
      items
        .map(function (item) {
          var img = item.image
            ? '<a href="' +
              item.url +
              '" class="wishlist-drawer__thumb"><img src="' +
              item.image +
              '" alt="" loading="lazy" width="72" height="72"></a>'
            : '<span class="wishlist-drawer__thumb wishlist-drawer__thumb--empty"></span>';
          var compare = item.compare
            ? '<s class="wishlist-drawer__compare">' + moneyFallback(item.compare) + '</s>'
            : '';
          return (
            '<li class="wishlist-drawer__item" data-wishlist-item="' +
            item.id +
            '">' +
            img +
            '<div class="wishlist-drawer__meta">' +
            '<a href="' +
            item.url +
            '" class="wishlist-drawer__title">' +
            (item.title || '') +
            '</a>' +
            '<div class="wishlist-drawer__price">' +
            '<span>' +
            moneyFallback(item.price) +
            '</span>' +
            compare +
            '</div>' +
            '<button type="button" class="wishlist-drawer__remove" data-wishlist-remove="' +
            item.id +
            '">' +
            removeText +
            '</button>' +
            '</div></li>'
          );
        })
        .join('') +
      '</ul>';
  }

  function setDrawer(open) {
    var drawer = qs('[data-wishlist-drawer]');
    var overlay = qs('[data-wishlist-drawer-overlay]');
    if (!drawer) return;
    var wasOpen = !drawer.hidden;
    if (open) {
      var cart = qs('[data-cart-drawer]');
      var cartOverlay = qs('[data-cart-drawer-overlay]');
      if (cart && !cart.hidden) {
        cart.hidden = true;
        if (cartOverlay) cartOverlay.hidden = true;
        if (typeof window.oniviasLockBodyScroll === 'function') window.oniviasLockBodyScroll(false);
      }
    }
    drawer.hidden = !open;
    if (overlay) overlay.hidden = !open;
    if (typeof window.oniviasLockBodyScroll === 'function') {
      if (open && !wasOpen) window.oniviasLockBodyScroll(true);
      if (!open && wasOpen) window.oniviasLockBodyScroll(false);
    } else {
      document.body.style.overflow = open ? 'hidden' : '';
    }
    if (open) renderDrawer();
  }

  function init() {
    document.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('[data-wishlist-toggle]');
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();
        var item = itemFromButton(toggleBtn);
        if (!item) return;
        var result = toggle(item);
        toggleBtn.classList.toggle('is-active', result.active);
        toggleBtn.setAttribute('aria-pressed', result.active ? 'true' : 'false');
        return;
      }

      var openBtn = e.target.closest('[data-wishlist-open]');
      if (openBtn) {
        e.preventDefault();
        setDrawer(true);
        return;
      }
      if (e.target.closest('[data-wishlist-close]')) {
        setDrawer(false);
        return;
      }
      var removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        remove(removeBtn.getAttribute('data-wishlist-remove'));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });

    document.addEventListener(EVENT, function (e) {
      var list = (e.detail && e.detail.items) || read();
      syncButtons(list);
      updateCount(list);
      var drawer = qs('[data-wishlist-drawer]');
      if (drawer && !drawer.hidden) renderDrawer(list);
    });

    var list = read();
    syncButtons(list);
    updateCount(list);

    window.OniviasWishlist = {
      read: read,
      add: add,
      remove: remove,
      toggle: toggle,
      has: has,
      open: function () { setDrawer(true); },
      close: function () { setDrawer(false); },
      sync: function () {
        var items = read();
        syncButtons(items);
        updateCount(items);
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
